const ACTIVATOR_VARIANTS = Object.freeze(["outlined", "appearance-link-inline"]);

export const props = Object.freeze({
  /**
   * Endpoint the dialog loads its options from.
   *
   * @type {String}
   * @default ""
   */
  optionsUrl: {
    type: String,
    default: "",
  },
  /**
   * Endpoint the dialog's form posts the choice to. It answers with a redirect to the MyChart page, which opens in a new tab.
   *
   * @type {String}
   * @default ""
   */
  formAction: {
    type: String,
    default: "",
  },
  /**
   * Id of the Physician the dialog opens MyChart for. Set this or `visitTypeId`.
   *
   * @type {String}
   * @default ""
   */
  physicianId: {
    type: String,
    default: "",
  },
  /**
   * Epic id of the visit type the dialog opens MyChart for. Set this or `physicianId`.
   *
   * @type {String}
   * @default ""
   */
  visitTypeId: {
    type: String,
    default: "",
  },
  /**
   * How the control that opens the dialog looks: `outlined` for a form field, `appearance-link-inline` for a line in an Information panel, where it takes the line's font and color.
   *
   * @type {String}
   * @default "outlined"
   * @values outlined, appearance-link-inline
   * @storybook-control select
   */
  activatorVariant: {
    type: String,
    default: "outlined",
    validator: (value) => ACTIVATOR_VARIANTS.includes(value),
  },
});
